export default __webpack_public_path__ + "static/media/priceTagIcon.0d6710f6.svg";